import { render } from "./MaterialStatusOrderView.vue?vue&type=template&id=250d45b4"
import script from "./MaterialStatusOrderView.vue?vue&type=script&lang=js"
export * from "./MaterialStatusOrderView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__